import { IAuthUser } from '@/modules/home/models';

export interface State {
    authUser: IAuthUser;
}

export const state = (): State => ({
    authUser: {
        iduser: 0,
        accessToken: '',
        isLogged: false,
        username: '',
        fullusername: '',
        isauthorized: false,
        functionalities: [],
    },
});
